import type {HTMLTemplateResult} from "lit";

import type {ClockSkin} from "../../../../domain/gimmicks/gimmick-registry";
import {renderChronoSkin} from "./chrono.skin";
import {renderFlapSkin} from "./flap.skin";
import {renderLedSkin} from "./led.skin";
import {renderRingSkin} from "./ring.skin";
import type {SkinInput} from "./skin-input";

/** The four clock looks, shared by the stopwatch and the timer (feature plans 0071, 0073). Keyed by `ClockSkin`,
 *  so a new look fails to compile until it has its renderer. */
export const CLOCK_SKIN_RENDERERS: Readonly<Record<ClockSkin, (input: SkinInput) => HTMLTemplateResult>> = {
    ring: renderRingSkin,
    chrono: renderChronoSkin,
    led: renderLedSkin,
    flap: renderFlapSkin,
};
